module.exports = __webpack_public_path__ + "static/media/404.fc515869.png";